document.addEventListener('DOMContentLoaded', function () {
	const testimonialImageBlocks = document.querySelectorAll(
		'.block-testimonial-image'
	);

	testimonialImageBlocks.forEach((block) => {
		const swiperEl = block.querySelector('.swiper');
		const swiperButtons = block.querySelectorAll(
			'.block-testimonial__swiper-buttons'
		);

		if (!swiperEl || !swiperButtons.length) {
			return;
		}

		// Wait for swiper to initialize
		const checkSwiper = setInterval(() => {
			if (swiperEl.swiper) {
				clearInterval(checkSwiper);
				const swiper = swiperEl.swiper;

				swiperButtons.forEach((buttonContainer) => {
					const prevBtn = buttonContainer.querySelector(
						'.swiper-button-prev'
					);
					const nextBtn = buttonContainer.querySelector(
						'.swiper-button-next'
					);

					if (prevBtn) {
						prevBtn.addEventListener('click', () => {
							swiper.slidePrev();
						});
					}

					if (nextBtn) {
						nextBtn.addEventListener('click', () => {
							swiper.slideNext();
						});
					}
				});
			}
		}, 100);

		// Clear interval after 5 seconds if swiper never initializes
		setTimeout(() => clearInterval(checkSwiper), 5000);
	});
});
